import { NAME } from './constants';
import { router } from './router';

export const WmsReception = {
	name: NAME,
	router,
};
